// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"3e7db37b","507":"aaa7d3c4"}[chunkId] + ".chunk.js";
};